import React, { ComponentProps } from 'react';
import { ConnectedPagesTree } from '../../_lib/components/ConnectedPages';
import { IConnectedPage } from '../../types/api/connectedPages/IConnectedPage';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { useSonTranslation } from '../../translation/useSonTranslation';
import ContentMessage from '../../_lib/components/ContentMessage/ContentMessage';
import { ContactPersonsFilter } from './partials/ContactPersonsFilter';
import { PageTypesFilter } from './partials/PageTypesFilter';
import { RolesFilter } from './partials/RolesFilter';
import { isEmptyArray, isNullOrUndefined } from '../../lib/typeGuards';
import { FilterLink } from '../../_lib/components/SelectLinks/SelectLinks';

type StructuralPageToPageTree = {
  connectedPages?: IConnectedPage[];
  additionalContent?: ContactPersonsFilter[];
  pageTypes?: FilterLink[];
  roles?: FilterLink[];
};

export function StructuralPageToPageTree({
  connectedPages,
  pageTypes,
  roles,
  additionalContent,
}: StructuralPageToPageTree) {
  const { t } = useSonTranslation('StructuralPageToPage');

  const getComponent = () => {
    if (isNullOrUndefined(connectedPages)) {
      return <ContentMessage text={t('noConnectedPages')} />;
    }
    if (isEmptyArray(connectedPages) || (connectedPages[0].childPages && isEmptyArray(connectedPages[0].childPages))) {
      return <ContentMessage text={t('filter.noResults')} />;
    }
    return <ConnectedPagesTree connectedPages={connectedPages[0].childPages} initialVisibleDepth={1} />;
  };

  return (
    <>
      <div className="structural-page-to-page-tree__filters">
        {additionalContent?.length && <ContactPersonsFilter contactPersons={additionalContent} />}
        {pageTypes?.length && <PageTypesFilter pageTypes={pageTypes} />}
        {roles?.length && <RolesFilter roles={roles} />}
      </div>
      {getComponent()}
    </>
  );
}

export const StructuralPageToPageTreeBlock = asBlock(StructuralPageToPageTree, BlockType.structuralPageToPageTree);
export type StructuralPageToPageTreeBlock = ComponentProps<typeof StructuralPageToPageTreeBlock>;
